export function t(key, replacements = {}) {
    const dictionary = window.i18n || {};
    let text = Object.prototype.hasOwnProperty.call(dictionary, key) ? dictionary[key] : key;

    Object.entries(replacements).forEach(([name, value]) => {
        text = String(text).split(':' + name).join(value ?? '');
    });

    return text;
}
